import BetButton from 'core/components/bet/BetButton'

export default class BetField extends PIXI.Container {
  constructor(data) {
    super()
    this._texture = game.getTextureFromAtlases(data.texture)
    this._data = data
    this.createBet()
  }

  createBet(){
    const bets = game.models.BetModel.getList()

    const buttonsInRow = bets.length <= this._data.numberOfButtons ? 4 : 5
    const distanceInRow = bets.length <= this._data.numberOfButtons ? 120 : 90
    const distanceInColumn = bets.length <= this._data.numberOfButtons ? 60 : 50
    const whCorrection = bets.length <= this._data.numberOfButtons ? 2 : 3

    this._data.orientation.port.x = bets.length <= this._data.numberOfButtons ? 38 : 58
    this._data.orientation.land.x = bets.length <= this._data.numberOfButtons ? 245 : 265

    let rowCount = 0
    let columnCount = 0
    let posX = 0
    let posY = 0

    for(let i = 0; i < bets.length; i++){
      posX = rowCount * distanceInRow
      posY = columnCount * distanceInColumn
      rowCount++
      if( (i + 1) % buttonsInRow === 0){
        rowCount = 0
        columnCount++
      }
      this.button = new BetButton({ texture: this._texture, x: posX, y: posY, name: 'bet-' + i, whCorrection, textPosY: this._data.textPosY, textPosX: this._data.textPosX })
      this.addChild(this.button)
    }
  }
}
